import styled from 'styled-components';

const ChartItemWrapper = styled.div`
  border-radius: 10px;
  cursor: move;
  transition: all 0.2s ease;
  height: 145px;
  width: 150px;
  &:hover {
    box-shadow: 0px 1.3px 15.3px 0px #0000000e;
  }
  .charticon {
    width: 42px;
    height: 42px;
  }
`;

const Elements = styled.div`
  height: 100%;
  width: 380px;
  left: ${(props) => (props.navOpen ? 'calc(100% - 380px)' : '100%')};
  transition: left 0.2s ease-out;
  .sticky-section {
    z-index: 2;
  }
`;

const DefaultViewWrapper = styled.div`
  position: absolute;
  font-size: 10px;
  font-weight: 500;
  background: #d9d9d9;
  border-radius: 10px 0px 8px;
  padding: 2px 10px;
  top: 0;
  left: 0;
`;

export { ChartItemWrapper, Elements, DefaultViewWrapper };
